export interface NavbarCustomization {
  backgroundColor?: string | null;
  textColor?: string | null;
}

export function buildNavbarCssRules(
  s: string,
  navbar: NavbarCustomization | null | undefined,
): string[] {
  const backgroundColor = navbar?.backgroundColor;
  const textColor = navbar?.textColor;
  const rules: string[] = [];
  if (backgroundColor) {
    rules.push(
      `${s}[data-ui="navbar"] { background-color: ${backgroundColor} !important; border-bottom: none !important; }`,
    );
  }
  if (textColor) {
    // Exclude the avatar subtree so the user's initials keep their bubble's
    // contrasting color. The navbar tags its avatar with
    // `data-ui="navbar-avatar"`.
    rules.push(
      `${s}[data-ui="navbar"] :not([data-ui="navbar-avatar"], [data-ui="navbar-avatar"] *) { color: ${textColor} !important; }`,
    );
  }
  return rules;
}
